// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.brand-logo[data-v-f1b91e36]{\n  width: 100%;margin: 0 auto;\n}\n\n\n", ""]);
// Exports
module.exports = exports;
